import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BaseMediaClientError } from '../../models/errors';
export var RequestError = /*#__PURE__*/function (_BaseMediaClientError) {
  _inherits(RequestError, _BaseMediaClientError);
  var _super = _createSuper(RequestError);
  function RequestError(reason, metadata, innerError) {
    var _this;
    _classCallCheck(this, RequestError);
    _this = _super.call(this, reason);
    _this.reason = reason;
    _this.metadata = metadata;
    _this.innerError = innerError;
    return _this;
  }
  _createClass(RequestError, [{
    key: "attributes",
    get: function get() {
      var reason = this.reason,
        _this$metadata = this.metadata,
        _this$metadata2 = _this$metadata === void 0 ? {} : _this$metadata,
        method = _this$metadata2.method,
        endpoint = _this$metadata2.endpoint,
        mediaRegion = _this$metadata2.mediaRegion,
        mediaEnv = _this$metadata2.mediaEnv,
        attempts = _this$metadata2.attempts,
        clientExhaustedRetries = _this$metadata2.clientExhaustedRetries,
        statusCode = _this$metadata2.statusCode,
        traceContext = _this$metadata2.traceContext,
        innerError = this.innerError;
      return {
        reason: reason,
        method: method,
        endpoint: endpoint,
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv,
        attempts: attempts,
        clientExhaustedRetries: clientExhaustedRetries,
        statusCode: statusCode,
        metadata: {
          traceContext: traceContext
        },
        innerError: innerError
      };
    }
  }]);
  return RequestError;
}(BaseMediaClientError);
export function isRequestError(err) {
  return err instanceof RequestError;
}